import {updateLabelConfig} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {FEDEX} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from './useLabelProperty.js'

const VALID_SHIPPER_TYPES = [FEDEX]

function labelPropertiesFunc(shipperType) {
  return VALID_SHIPPER_TYPES.includes(shipperType)
    ? [`${shipperType}__label_type`]
    : []
}

export default function LabelType() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = LabelType.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigSelect
      label="Label Type"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="label_type"
    />
  )
}

LabelType.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
